(function ($) {

    $.fn.extend({

        sorsBanner: function (options) {
            var defaults = {
                maxWidth: 1920,
                maxHeight: 554,
                evenColor: "#ccc",
                oddColor: "#eee"
            };

            var options2 = $.extend(defaults, options);
            var firstWinWidth = $(window).width();

            return this.each(function () {

                var o = options2;
                var obj = $(this);
                var items = $("div.carousel-inner > div.item", obj);
                var itemsleft = 0;

                $(obj).css("max-width", o.maxWidth).css("max-height", o.maxHeight);

                $(window).resize(function myfunction() {
                    onResize(firstWinWidth, items);
                });

                onResize(firstWinWidth, items);

                $('img.CarouselImg').on('load', function () {
                    onResize(firstWinWidth, items);
                });

            });
        }
    });

})(jQuery);

function onResize($firstWinWidth, $items) {

    var winWidth = $(window).width();

    if ($firstWinWidth <= winWidth) {

        //$.each($(".CarouselImg"), function () {

        //    if (isMobile(true)) {

        //        if ($(this).attr("data-src") != undefined && $(this).attr("data-src").length > 0) {

        //            $(this).attr("src", $(this).attr("data-src") + "?quality=100&width=" + winWidth);
        //        }
        //    }
        //    else {

        //        if ($(this).attr("data-src") != undefined && $(this).attr("data-src").length > 0) {

        //            $(this).attr("src", $(this).attr("data-src") + "?quality=80");
        //        }
        //    }
        //});

    }

    $($items).each(function () {

        var ow = $("img.CarouselImg", this).data("ow");
        var oh = $("img.CarouselImg", this).data("oh");
        var xw = $("img.CarouselImg", this).width();
        var xh = $("img.CarouselImg", this).height();

        //console.log("###ow:" + ow + ", xw:" + xw, "oh:" + oh + ", xh:" + xh);

        if (xw == 0 || xw == 100) {
            xw = ow;
        }
        if (xh == 0) {
            xh = oh;
        }


        //Banner Text Resize
        $(".BannerText", this).each(function () {
            var ResizeRatio = (ow / xw);
            //console.log("ow:" + ow + ", xw:" + xw, "oh:" + oh + ", xh:" + xh);

            var AW = $(this).data("w");
            var AH = $(this).data("h");
            var AX = $(this).data("x");
            var AY = $(this).data("y");
            var AZ = $(this).data("z");
            var AFC = $(this).data("font-color");
            var AFS = $(this).data("font-size");
            var AFSt = $(this).data("font-style");
            var AFW = $(this).data("font-weight");

            $(this).css({
                "width": AW / ResizeRatio,
                "height": AH / ResizeRatio,
                "margin-top": AY / ResizeRatio,
                "margin-left": AX / ResizeRatio,
                "z-index": AZ,
                "color": AFC,
                "font-size": AFS / ResizeRatio,
                "font-style": AFSt,
                "font-weight": AFW
            });
            //console.log(ResizeRatio);
            //console.log("resizeRatio:" + ResizeRatio + ", AW:" + AW + ", AH:" + AH + ", AX:" + AX + ", AY." + AY + ", AZ:" + AZ + ", AFC:" + AFC + ", AFS" + AFS + ", AGFT:" + AFSt + ", AFW:" + AFW);
        });
    });

}

$(document).ready(function () {


    $(".SBanner").sorsBanner({
        maxWidth: "auto",
        maxHeight: "auto"
    });


    $(".SBanner").hammer().on("swiperight", function (e) {

        $(this).carousel('prev');
        e.stopPropagation();
        e.preventDefault();
    });


    $(".SBanner").hammer().on("swipeleft", function (e) {

        $(this).carousel('next');

        e.stopPropagation();
        e.preventDefault();
    });
    
});
